const Q = require(`q`);
const _ = require(`underscore`);
const __request = require(`./__request/__request_contentType_form`);

// 订单列表查询
// 接口文档地址：http://183.58.24.99:9999/swagger-ui.html#/domestic-buyer-manage-order-controller/chgStatesUsingPOST
const flight_domestic_buyer_manage_order_chgStates = (pParameter) => {
  if (!pParameter) pParameter = {};

  const p = {
    method: 'post',
    urlSuffix: 'flight/domestic/buyer/manage/order/chgStates',
    data: {}
  };
  return Q.when()
    .then(function () {
      return __request(p);
    })
    .catch(function (ex) {
      console.error(ex);
      if (ex) {
        if (ex.stack) {
          console.error(ex.stack);
        }
      }
      return Q.reject(ex);
    })
    ;
};
module.exports = flight_domestic_buyer_manage_order_chgStates;
